import { delay, put, takeEvery } from 'redux-saga/effects';
import { removeNotification } from '../../actions/notifications';
import { CREATE_NOTIFICATION, NOTIFICATION_DELAY } from '../../constants/notifications';

/** @param {{payload: CreateNotificationPayload, type: string}} action */
function* handleNotificationCreation({ payload }) {
  const { disableAutoRemove } = payload;

  if (disableAutoRemove) {
    return;
  }

  yield delay(NOTIFICATION_DELAY);

  yield put(removeNotification({ id: payload.id }));
}

export default function* () {
  yield takeEvery(CREATE_NOTIFICATION, handleNotificationCreation);
}
